function removeElement(element) {
    if (!element) {
        return;
    }
    if (element.parentNode === null) {
        return;
    }
    element.parentNode.removeChild(element);
}

function createIframe(endpoint) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', endpoint);
    iframe.setAttribute('id', endpoint);
    iframe.setAttribute('tabIndex', '-1');
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.style.position = 'absolute';
    iframe.style.top = '-100px';
    iframe.style.left = '-100px';
    iframe.style.pointerEvents = 'none';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
}

export function renewIframe(endpoint) {
    const old = document.getElementById(endpoint);
    removeElement(old);
    setTimeout(() => createIframe(endpoint), old ? 500 : 0);
}
